// components/PoolMobileRow.js
import React, { useState, useEffect, useCallback } from "react";
import { Accordion } from "react-bootstrap";
import { Link } from "react-router-dom";
import useWallet from "../../../hooks/useWallet";
import { useStake } from "../../../hooks/useStake";
import { useTheme } from "../../../hooks/ThemeProvider";
import Tvl from "../../../shared/Tvl";
import { defaultUserProfile } from "../../../utils/constant";
import ChildPoolApr from "../../../shared/ChildPoolApr";

const PoolMobileRow = ({ pool, index, onShare, eventKey, rootPoolData }) => {
  const [availableStakes, setAvailableStakes] = useState({
    amountETH: "0",
    restakeAmountETH: "0",
    claimCountdown: "00D:00H:00M",
    amountNumber: 0,
    restakeAmountNumber: 0,
  });
  const { theme, toggle } = useTheme();
  const { address } = useWallet();
  const { getAvailableStakes } = useStake();


  // console.log(rootPoolData, 'rootPoolDatarootPoolData');

  const fetchAvailableStakes = useCallback(async () => {
    if (!pool?.contractAddress || !address) return;

    try {
      const stakes = await getAvailableStakes(pool.contractAddress, address);

      setAvailableStakes({
        amountETH: stakes?.amountETH || "0",
        restakeAmountETH: stakes?.restakeAmountETH || "0",
        claimCountdown: stakes?.claimCountdown || "00D:00H:00M",
        amountNumber: stakes?.amountNumber || 0,
        restakeAmountNumber: stakes?.restakeAmountNumber || 0,
        claimTime: stakes?.claimTime,
      });
    } catch (error) {
      console.error("Failed to fetch available stakes:", error);
    }
  }, [pool, address, getAvailableStakes]);

  useEffect(() => {
    fetchAvailableStakes();
  }, [fetchAvailableStakes]);

  return (
    <Accordion.Item eventKey={eventKey}>
      <Accordion.Header>
        <div className="parent">
          <div className="first">
            <h5>#</h5>
            <h6>{index + 1}</h6>
          </div>
          <div className="second">
            <h5 className="parasecond">Creator</h5>
            <h6>
              <img
                src={
                  pool?.createdBy?.imageUrl
                    ? pool.createdBy.imageUrl
                    : defaultUserProfile?.imageUrl
                }
                alt="creator"
                className="img-fluid imgphonnne"
              />
              {pool?.createdBy?.name || defaultUserProfile?.name}
            </h6>
          </div>
          <div className="third">
            <h5>APR</h5>
            <h6><ChildPoolApr childPoolContractAddress={pool?.contractAddress} rootPoolAddress={rootPoolData?.contractAddress} rootPoolEndDate={rootPoolData?.poolEndDate} rootPoolRewardAmount={rootPoolData?.rewardAmount} rootPoolStartDate={rootPoolData?.createdAt}/></h6>
          </div>
        </div>
      </Accordion.Header>

      <Accordion.Body>
        <div className="maincontent">
          <div className="inneerparent">
            <div className="left">
              <h5>TVL</h5>
              <h6><Tvl contractAddress={pool?.contractAddress} poolType={"childPool"} /></h6>
            </div>
            <div className="left">
              <h5>Fee</h5>
              <h6>{pool?.creatorFeePercent}%</h6>
            </div>
          </div>

          <div className="inneerparent">
            {/* <div className="left">
              <h5>Lock Options</h5>
              <h6>-</h6>
            </div> */}
            <div className="left">
              <h5>My Stake</h5>
              <h6 className="grey">
                {availableStakes?.amountETH
                  ? Number(availableStakes.amountETH).toLocaleString(undefined, { maximumFractionDigits: 4 })
                  : 0}
              </h6>
            </div>
          </div>

          <div className="lastbtn">
            <span onClick={() => onShare(pool, true)}>
              {
                theme === 'dark' ? <img src="/assets/share.svg" alt="Share" /> :
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M9 1.5V11.25" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M12 4.5L9 1.5L6 4.5" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M3 9V15C3 15.3978 3.15804 15.7794 3.43934 16.0607C3.72064 16.342 4.10218 16.5 4.5 16.5H13.5C13.8978 16.5 14.2794 16.342 14.5607 16.0607C14.842 15.7794 15 15.3978 15 15V9" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
              }

            </span>
            <Link to={`/stakingpool?id=${pool?._id}`}>
              <button className="detail">
                Details
                {
                  theme === 'dark' ? <img src="/assets/white.svg" alt="Arrow" /> :
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path d="M9 4L11 6L9 8" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M1 6H11" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                }

              </button>
            </Link>
          </div>
        </div>
      </Accordion.Body>
    </Accordion.Item>
  );
};

export default PoolMobileRow;
